// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { HEADER_BREAKPOINT } from "@steiner/Overrides/Pages/Header";
import { mainNavigationStyles } from "@steiner/Overrides/Widgets/Header/MainNavigation";
import NavArrowDown from "@steiner/XDL/Icons/NavArrowDown";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        display: flex;
        gap: 26px;
        justify-content: flex-start;
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        &:hover span + div {
            display: block;
        }
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        & > ${TypographyStyle} {
            display: flex;
            align-items: center;
            gap: 4px;
            & > ${IconWrapper} {
                color: ${color("common.ui15")};
            }
        }

        &.primary > ${TypographyStyle} {
            &,
            & > ${IconWrapper} {
                color: ${color("secondary")};
            }
        }

        &[data-open],
        &:not([disabled]):hover {
            & > ${TypographyStyle} {
                color: ${color("secondary")};
                & > ${IconWrapper} {
                    color: ${color("secondary")};
                    transform: rotate(180deg);
                }
            }
        }
    `,
};

mainNavigationStyles.menuItemTypography = {
    size: 16,
    color: "common.white",
    weight: "bold",
    lineHeight: "19px",
    css: css`
        text-transform: uppercase;
        ${ellipsis(2)}
    `,
};

mainNavigationStyles.menuItemIcon = {
    src: NavArrowDown,
    size: 12,
};

mainNavigationStyles.menuWrapper = {
    css: css`
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            display: none;
        }
    `,
};

mainNavigationStyles.mobileMenuWrapper = {
    css: css`
        display: none;
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            display: block;
        }
    `,
};
